import { Tag } from "antd";
import styles from "./CheckResult.module.less";
import iconXm from "@/asserts/images/contract/xm.gif";
import iconLine from "@/asserts/images/contract/line2.png";
import { useTranslation } from "react-i18next";

type Props = {
  result: string;
  urlList: string[];
  onScrollTo: (pageNo: number) => void;
};

export function CheckResult({ result, urlList, onScrollTo }: Props) {
  const { t } = useTranslation("contractManagement");

  let list: any[] = [];

  try {
    if (!result) {
      throw new Error(t("检测结果为空"));
    }

    const arr = JSON.parse(result);
    list = arr.map((item: any, index: any) => {
      const urlIndex = urlList?.findIndex(
        (urlItem: any) => urlItem === item.url,
      );
      return {
        ...item,
        pageNo: urlIndex && urlIndex !== -1 ? urlIndex + 1 : null,
      };
    });
  } catch (error) {
    console.log("error", error);
  }

  return (
    <div className={styles.rightContent}>
      <div className="annotations-sidebar">
        <div className="title">
          <div className="box">
            <img src={iconXm} className="pic" alt="" />
            <div className="t">
              {t("审查结果")}
              <img src={iconLine} className="line" alt="" />
            </div>
          </div>
        </div>
        <div className="content">
          {list.length ? (
            <table className="myTable">
              <thead>
                <tr>
                  <td>{t("存在问题")}</td>
                  <td>{t("建议修改内容")}</td>
                  <td>{t("风险程度")}</td>
                </tr>
              </thead>
              <tbody>
                {list.map((item: any, index: number) => (
                  <tr onClick={() => onScrollTo(item.pageNo)}>
                    {item.content ? (
                      <td>
                        {index + 1}.“{item.content}”
                        <span className="risk">({item.risk})</span>
                      </td>
                    ) : (
                      <td>{item.clauseAbstract}</td>
                    )}

                    <td>{item.suggestion ? item.suggestion : t("暂无")}</td>
                    <td>
                      {item.level === "高" && (
                        <Tag color="#FF0000" className="tag">
                          {t("高")}
                        </Tag>
                      )}
                      {item.level === "中" && (
                        <Tag color="#FF9B00" className="tag">
                          {t("中")}
                        </Tag>
                      )}
                      {item.level === "低" && (
                        <Tag color="#05AC1B" className="tag">
                          {t("低")}
                        </Tag>
                      )}
                      {!item.level && t("暂无")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="test">{t("检测正常")}</div>
          )}
        </div>
      </div>
    </div>
  );
}
